import React, { FunctionComponent, useContext } from "react";

interface IProps {
    pageTitle?: string;
    children: React.ReactNode;
}

const PageTitleContext = React.createContext("");
const UNKNOWN_PAGE = "UNKNOWN";
export const usePageTitle = () => useContext(PageTitleContext) || UNKNOWN_PAGE;

export const PageTitleProvider: FunctionComponent<IProps> = ({
  pageTitle,
  children,
}) => (
  <PageTitleContext.Provider value={pageTitle || UNKNOWN_PAGE}>
    {children }
  </PageTitleContext.Provider>
);
